import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { DateRangePickerInput } from "@/components/ui/date-range-picker-input";
import { TrashIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";

export class VehicleRegistrationDateRangeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "registrationDate";
  readonly labelSingular = "common:RegistrationDate";
  readonly labelPlural = "common:RegistrationDate";
  readonly placeholder = "common:RegistrationDate";
  readonly searchPlaceholder = "";
  readonly emptyText = "";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return { options: [], isLoading: false, error: null };
  }

  render(props: BaseFilterProps) {
    return <RegistrationDateRangeFilterComponent {...props} />;
  }
}

function RegistrationDateRangeFilterComponent({ selectedValues, onSelectionChange, disabled }: BaseFilterProps) {
  const { t } = useTranslation(["common"]);

  const from = selectedValues[0] ?? "";
  const to = selectedValues[1] ?? "";

  const handleFromChange = (value: string) => {
    onSelectionChange(value === "" && to === "" ? [] : [value, to]);
  };

  const handleToChange = (value: string) => {
    onSelectionChange(from === "" && value === "" ? [] : [from, value]);
  };

  const handleClear = () => {
    onSelectionChange([]);
  };

  const hasValues = from !== "" || to !== "";

  return (
    <div className="flex flex-col">
      <span className="text-sm font-medium">{t("common:RegistrationDate")}</span>
      <div className="flex items-center gap-2">
        <DateRangePickerInput
          from={from}
          to={to}
          onFromChange={handleFromChange}
          onToChange={handleToChange}
          disabled={disabled}
          className="min-w-0 flex-1"
        />
        <Button
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Icon}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClear();
          }}
          className="shrink-0"
          disabled={!hasValues || disabled}
          aria-label={t("common:Remove")}
        >
          <TrashIcon className="size-4" />
        </Button>
      </div>
    </div>
  );
}
